import AF from '../utlis/AF';

export default class WindowHeight {
  resizeTimer = null;
  winHeight = 0;
  oldwinHeight = 0;
  af = AF.instance();
  el = null;

  constructor(element) {
      this.el = element;
      this.onResize = this.onResize.bind(this);
      this.read = this.read.bind(this);
      this.run = this.run.bind(this);
      this.write = this.write.bind(this);

      if (document.readyState === 'complete') {
          this.run();
      } else {
          window.addEventListener("load", this.run);
      }
  }

  run() {
      this.af.onNextRead(this.read);
      this.af.onNextWrite(this.write);
      window.addEventListener('resize', this.onResize);
  }

  read() {
      this.winHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  }

  write() {
      if (this.winHeight !== 0 && Math.abs(this.oldwinHeight - this.winHeight) > 120) {
          this.oldwinHeight = this.winHeight;
          this.el.style.minHeight = this.winHeight + 'px';
      }
  }

  onResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
          // Run code here, resizing has "stopped"
          this.af.onNextRead(this.read);
          this.af.onNextWrite(this.write);
      }, 250);
  }

  destroy() {
      window.removeEventListener('resize', this.onResize);
  }
}